import { Link, useNavigate } from "react-router-dom";
import { Wese_NewProductsFlyers } from "./Wese_NewProductsFlyers";
import { Wese_NewProducts } from "./Wese_NewProducts";
import { CatalogueContainer } from "./catalogueContainer";
import { WES_eCatalogue_Flyers } from "./WES_eCatalogue_Flyers";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import { CustomDateRangePicker } from "../../Layout/Common/customDateRangePicker";
import { axiosInstance, axiosWithoutAuth } from "../../axios/axiosInstance";
import moment from "moment";
import { base64Encode, isValidArray, scrollToFocuse } from "../../Layout/Common/common";
import { CatalogueHeader } from "./catalogueHeader";
import { NewsFlyersFeaturedContainer } from "./NewsFlyers/newsFlyersFeaturedContainer";
import { set } from "lodash";

export const Online_catalogue_Main = () => {
  const history = useNavigate();
  const [activeTab, setActiveTab] = useState("catalogue");
  const [gridTab, setGridTab] = useState("grid");
  const [UserResponse, setUserResponse] = useState("");
  const { isAuthenticated, userId, companyId, setUser, setAthuLoading, emailAddress, role } = useAuth();
  const [CategoryList, setCategoryList] = useState("");
  const [UserResponseCataloge, setUserResponseCataloge] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "", displayText: "" });
  // The filters the visible result set was produced with, so the "no flyers found"
  // message describes what was actually searched rather than what is typed right now.
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [filterData, setFilterData] = useState(UserResponse);
  const dateRef = useRef();
  const flyersRef = useRef();

  useEffect(() => {
    // Get query params from URL
    const pathname = window.location.pathname.toLowerCase();
    // Example: ?tab=true OR ?tab=false
    if (pathname === "/online-catalogue") {
      setActiveTab("catalogue");
    } else if (pathname === "/wesnews") {
      setActiveTab("flyers");
    }
    InitLoadCataloge();
    InitLoad();
    InitLoadCategory();
  }, []);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    scrollToFocuse(flyersRef.current, 0, 100);
  };
  const InitLoadCategory = async () => {
    var data = {
      UserId: userId ? String(userId) : "999",
    };
    axiosWithoutAuth
      .post("WeseNewProductsFlyers/InitLoadCategory", data)
      .then((response) => {
        if (response.data != "") {
          var result = response.data;
          setCategoryList(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };
  const InitLoad = () => {
    var data = {
      UserId: userId ? String(userId) : "999",
    };
    axiosWithoutAuth
      .post("WeseNewProductsFlyers/InitLoad", data)
      .then((response) => {
        if (response.data != "") {
          var result = response.data;
          setUserResponse(response.data);
          setFilterData(response.data);
          setTotalPage(Math.ceil(response.data.length / 12));
        }
      })
      .catch((error) => console.log(error.message));
  };
  const InitLoadCataloge = () => {
    var data = {
      UserId: userId ? String(userId) : "999",
    };
    fetch("https://cdn.wes.com.au/WesReact/categorySlider/categoryCateloge.txt?v=" + new Date().getTime())
      .then((res) => res.json())
      .then((responsedata) => {
        if (responsedata && isValidArray(responsedata.category)) setUserResponseCataloge(responsedata.category);
      })
      .catch((err) => console.error("Error fetching catalogue data:", err));
  };
  // Search text and date range are combined with AND - a flyer must match both to show.
  // `dtRange` comes straight from the picker's apply event, because the dateRange state
  // set alongside it is not visible to this call yet.
  const applyFilters = (dtRange) => {
    if (!isValidArray(UserResponse)) return;

    const search = searchText?.trim().toLowerCase();
    const range = dtRange ?? dateRange;
    const hasDateFilter = !!range.startDate && !!range.endDate;

    const filteredData =
      !search && !hasDateFilter
        ? UserResponse
        : UserResponse.filter((item) => {
            const matchesSearch =
              !search ||
              item.categoryName?.toLowerCase().includes(search) ||
              item.categoryId?.toString().toLowerCase().includes(search);

            if (!matchesSearch) return false;
            if (!hasDateFilter) return true;

            // modifiedDate comes from the API as dd-MM-yyyy, and can be blank.
            const itemDate = moment(item.modifiedDate, "DD-MM-YYYY", true);
            return itemDate.isValid() && itemDate.isBetween(range.startDate, range.endDate, "day", "[]");
          });

    setFilterData(filteredData);
    setTotalPage(Math.ceil(filteredData.length / 12));
    setCurrentPage(1);
    setAppliedFilters(search || hasDateFilter ? { search, dateText: hasDateFilter ? range.displayText : "" } : null);
    scrollToFocuse(flyersRef.current, 0, 100);
  };
  // The one search path, shared by the Search button and the picker popup's Apply button.
  // It reads the range straight off the picker, so it works whether the user pressed Apply
  // or just picked dates and went to Search. commitSelection() returns null when the user
  // has not picked anything (or pressed Cancel), which drops the date filter.
  const runSearch = () => {
    const picked = dateRef.current?.commitSelection?.() ?? { startDate: "", endDate: "", displayText: "" };
    setDateRange(picked);
    applyFilters(picked);
  };
  const handleSearchClick = () => runSearch();
  const handleReset = () => {
    setSearchText("");
    setDateRange({ startDate: "", endDate: "", displayText: "" });
    setAppliedFilters(null);
    setFilterData(UserResponse);
    setTotalPage(Math.ceil(isValidArray(UserResponse) ? UserResponse.length / 12 : 0));
    setCurrentPage(1);
    dateRef.current?.reset();
    scrollToFocuse(flyersRef.current, 0, 100);
  };
  // Apply and Cancel in the picker popup both run the same search as the Search button.
  const handleDateChange = () => runSearch();
  return (
    <>
      <CatalogueHeader activeTab={activeTab} setActiveTab={setActiveTab} />
      <section className="catalogueTab-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-md-12">
              <div className="catalogueTabs-list">
                <ul className="p-0 m-0">
                  <li className="nav-item">
                    <Link
                      className={`nav-link ${activeTab === "catalogue" ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("catalogue");
                      }}
                    >
                      WES Catalogue
                    </Link>
                  </li>
                  <li className="nav-item" style={{ display: userId ? "block" : "none" }}>
                    <Link
                      className={`nav-link ${activeTab === "flyers" ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("flyers");
                      }}
                    >
                      WES News Flyers (Latest Products)
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {activeTab === "catalogue" && (
        <section className="catalogueContent-section" id="catalogue">
          <div className="container-fluid container-lg">
            <div className="row">
              <CatalogueContainer viewBox={gridTab} UserResponse={UserResponseCataloge} />
              <div className={`${gridTab === "grid" ? "col-md-4 col-lg-3" : "col-md-4"}`}>
                <div className="catalogueList-title latest-flyer">
                  <h4 className="mb-0">Latest Flyers</h4>
                  <div className="sort-filters d-none d-md-block">
                    <div className="card-row">
                      <Link
                        className={`grid-products ${gridTab === "grid" ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setGridTab("grid");
                        }}
                      >
                        <span className="wes-card-filter"></span>
                      </Link>
                      <Link
                        className={`row-products ${gridTab === "row" ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setGridTab("row");
                        }}
                      >
                        <span className="wes-row-filter"></span>
                      </Link>
                    </div>
                  </div>
                </div>
                <WES_eCatalogue_Flyers viewBox={gridTab} CategoryList={CategoryList} />
              </div>
            </div>
          </div>
        </section>
      )}
      {activeTab === "flyers" && (
        <section className="catalogueContent-section" id="flyers">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="catalogueList-title latest-flyer">
                  <h4 className="mb-0 text-center text-md-start">Featured</h4>
                  <div className="catalogFeature-filter">
                    <div className="input-group orders-search">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter catalogue or id"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearchClick();
                          }
                        }}
                      />
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </div>
                    <CustomDateRangePicker ref={dateRef} onChange={handleDateChange} />

                    <div className="popupBtns">
                      <div className="button-effect popupBtns-two">
                        <button type="submit" className="btn btn-products theme-primary" onClick={handleSearchClick}>
                          Search
                        </button>
                        <button type="button" className="btn btn-products btn-unavailable" onClick={handleReset}>
                          Reset
                        </button>
                      </div>
                    </div>
                    <div className="sort-filters">
                      <div className="card-row">
                        <Link
                          className={`grid-products ${gridTab === "grid" ? "active" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setGridTab("grid");
                          }}
                        >
                          <span className="wes-card-filter"></span>
                        </Link>
                        <Link
                          className={`row-products ${gridTab === "row" ? "active" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setGridTab("row");
                          }}
                        >
                          <span className="wes-row-filter"></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <NewsFlyersFeaturedContainer viewBox={gridTab} CategoryList={CategoryList} pageNo={currentPage} />
              </div>
            </div>
            <div ref={flyersRef} className="row">
              <div className="col-md-12">
                <div className="catalogueList-title latest-flyer">
                  <h4 className="mb-0">WES News Flyers</h4>
                </div>
              </div>
              <div className="col-md-12">
                {appliedFilters && !isValidArray(filterData) ? (
                  <div className="newsFlyer-noResult">
                    <p className="mb-0">
                      No flyers found
                      {appliedFilters.search ? <> for &ldquo;{appliedFilters.search}&rdquo;</> : null}
                      {appliedFilters.dateText ? <> between {appliedFilters.dateText}</> : null}.
                    </p>
                    <div className="button-effect">
                      <button type="button" className="btn btn-products btn-unavailable" onClick={handleReset}>
                        Reset
                      </button>
                    </div>
                  </div>
                ) : (
                  <Wese_NewProductsFlyers viewBox={gridTab} UserResponse={filterData} pageNo={currentPage} />
                )}
              </div>
            </div>
            <div className="row mt-4" style={{ display: totalPage > 0 ? "block" : "none" }}>
              <div className="col-md-12">
                <nav className="newsFlyerPagination">
                  <ul className="pagination">
                    {/* First Page */}
                    <li className="page-item">
                      <Link className="page-link" onClick={() => setCurrentPage(1)}>
                        <i className="fa-solid fa-angles-left"></i>
                      </Link>
                    </li>

                    {/* Previous */}
                    <li className="page-item">
                      <Link className="page-link" onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}>
                        <i className="fa-solid fa-angle-left"></i>
                      </Link>
                    </li>

                    {/* Page Numbers */}
                    {[...Array(totalPage)].map((_, index) => (
                      <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                        <Link className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </Link>
                      </li>
                    ))}

                    {/* Next */}
                    <li className="page-item">
                      <Link
                        className="page-link"
                        onClick={() => currentPage < totalPage && setCurrentPage(currentPage + 1)}
                      >
                        <i className="fa-solid fa-angle-right"></i>
                      </Link>
                    </li>

                    {/* Last Page */}
                    <li className="page-item">
                      <Link className="page-link" onClick={() => setCurrentPage(totalPage)}>
                        <i className="fa-solid fa-angles-right"></i>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
